/* eslint-disable */
import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBars,
  faInfoCircle,
  faTag,
  faEnvelope,
  faUserPlus,
} from '@fortawesome/free-solid-svg-icons';
import { faInstagram } from '@fortawesome/free-brands-svg-icons';
import { images } from '../../assets/images';
import { ROUTES } from '../../config/routes';
import { useAuth } from '../../../features/auth/context/AuthContext';
import { getAvatarEmoji } from '../../../features/users/utils/avatarCatalog';

export default function Navbar() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const sidebarRef = useRef(null);
  const dropdownRef = useRef(null);
  const { isAuthenticated, user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    function handleClickOutside(event) {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        setIsSidebarOpen(false);
      }
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  function handleAnchorClick(event, id) {
    event.preventDefault();
    setIsSidebarOpen(false);

    if (location.pathname === ROUTES.home) {
      const element = document.getElementById(id);
      if (element) {
        window.scrollTo({ top: Math.max(element.offsetTop - 96, 0), behavior: 'smooth' });
      }
      return;
    }

    navigate({ pathname: ROUTES.home, hash: `#${id}` });
  }

  function handleLogout() {
    logout();
    setIsDropdownOpen(false);
    navigate(ROUTES.login);
  }

  return (
    <>
      <button
        onClick={() => setIsSidebarOpen((previous) => !previous)}
        className="md:hidden text-black z-50 p-3 fixed top-4 left-4 bg-white rounded shadow-lg"
      >
        <FontAwesomeIcon icon={faBars} size="lg" />
      </button>

      <div
        ref={sidebarRef}
        className={`fixed top-0 left-0 w-64 bg-black text-white transform ${isSidebarOpen ? 'translate-x-0' : '-translate-x-full'} transition-transform h-full z-40 md:hidden`}
      >
        <Link to={ROUTES.home} className="flex items-center px-4 py-2">
          <img src={images.logo} alt="Logo" className="h-10 mr-2" /> Mundolandia
        </Link>
        <a href="#informacion" onClick={(event) => handleAnchorClick(event, 'informacion')} className="px-4 py-2 flex items-center">
          <FontAwesomeIcon icon={faInfoCircle} className="mr-2" /> Información
        </a>
        <a href="#precio" onClick={(event) => handleAnchorClick(event, 'precio')} className="px-4 py-2 flex items-center">
          <FontAwesomeIcon icon={faTag} className="mr-2" /> Precio
        </a>
        <a href="#contacto" onClick={(event) => handleAnchorClick(event, 'contacto')} className="px-4 py-2 flex items-center">
          <FontAwesomeIcon icon={faEnvelope} className="mr-2" /> Contacto
        </a>
        <Link to={ROUTES.voucherLookup} className="px-4 py-2 flex items-center">
          Consultar bono
        </Link>
        <Link to={ROUTES.register} className="px-4 py-2 flex items-center">
          <FontAwesomeIcon icon={faUserPlus} className="mr-2" /> Registro
        </Link>
        {isAuthenticated && (
          <>
            <Link to={ROUTES.admin} className="px-4 py-2 flex items-center">Panel interno</Link>
            <Link to={ROUTES.adminProfile} className="px-4 py-2 flex items-center">Mi perfil</Link>
            <button onClick={handleLogout} className="px-4 py-2 flex items-center w-full text-left">Cerrar sesión</button>
          </>
        )}
      </div>

      <nav className="hidden md:flex fixed top-0 z-50 w-full items-center justify-between px-6 py-4 bg-white shadow">
        <div className="flex items-center gap-6">
          <Link to={ROUTES.home} className="flex items-center text-black font-bold text-lg uppercase">
            <img src={images.logo} alt="Logo" className="h-10 mr-2" /> Mundolandia
          </Link>
          <a href="#informacion" className="hover:text-blueGray-600 text-sm font-semibold" onClick={(event) => handleAnchorClick(event, 'informacion')}>
            Información
          </a>
          <a href="#precio" className="hover:text-blueGray-600 text-sm font-semibold" onClick={(event) => handleAnchorClick(event, 'precio')}>
            Precio
          </a>
          <a href="#contacto" className="hover:text-blueGray-600 text-sm font-semibold" onClick={(event) => handleAnchorClick(event, 'contacto')}>
            Contacto
          </a>
          <Link to={ROUTES.voucherLookup} className="hover:text-blueGray-600 text-sm font-semibold">Consultar bono</Link>
          <Link to={ROUTES.restriction} className="hover:text-blueGray-600 text-sm font-semibold">Restricciones</Link>
          <Link to={ROUTES.birthdays} className="hover:text-blueGray-600 text-sm font-semibold">Cumpleaños</Link>
        </div>

        <div className="flex items-center gap-3">
          <a
            href="https://www.instagram.com/mundolandiapark2/"
            target="_blank"
            rel="noreferrer"
            className="text-blueGray-700 hover:text-blueGray-500"
          >
            <FontAwesomeIcon icon={faInstagram} />
          </a>

          {isAuthenticated && (
            <div ref={dropdownRef} className="relative">
              <button
                onClick={() => setIsDropdownOpen((prev) => !prev)}
                className="w-10 h-10 rounded-full bg-gradient-to-br from-orange-400 to-amber-500 flex items-center justify-center text-lg shadow-md hover:shadow-lg transition-shadow"
                title={user?.name || 'Perfil'}
              >
                {getAvatarEmoji(user?.avatarIndex)}
              </button>

              {isDropdownOpen && (
                <div className="absolute right-0 mt-2 w-56 rounded-2xl bg-white border border-gray-200 shadow-xl py-2 z-50 animate-in fade-in slide-in-from-top-2">
                  <div className="px-4 py-3 border-b border-gray-100">
                    <p className="font-semibold text-slate-900 truncate">{user?.name || 'Usuario'}</p>
                    <p className="text-xs text-slate-500 truncate">{user?.email}</p>
                  </div>
                  <Link
                    to={ROUTES.admin}
                    onClick={() => setIsDropdownOpen(false)}
                    className="block px-4 py-2.5 text-sm text-slate-700 hover:bg-gray-50 transition"
                  >
                    Panel interno
                  </Link>
                  <Link
                    to={ROUTES.adminProfile}
                    onClick={() => setIsDropdownOpen(false)}
                    className="block px-4 py-2.5 text-sm text-slate-700 hover:bg-gray-50 transition"
                  >
                    Mi perfil
                  </Link>
                  <div className="border-t border-gray-100 mt-1 pt-1">
                    <button
                      onClick={handleLogout}
                      className="block w-full text-left px-4 py-2.5 text-sm text-red-600 hover:bg-red-50 transition"
                    >
                      Cerrar sesión
                    </button>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </nav>
    </>
  );
}
